import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';

import "./assets/css/index.css";
import "./assets/css/admin.css";

import { VToggle } from 'vuetensils/src/components';
import { VDropdown } from 'vuetensils/src/components';
import { VIntersect } from 'vuetensils/src/components';


axios.defaults.paramsSerializer = function (paramObj) {
    const params = new URLSearchParams()
    for (const key in paramObj) {
        params.append(key, paramObj[key])
    }

    return params.toString()
}

axios.defaults.timeout = 100000;
axios.defaults.withCredentials = true;
axios.defaults.baseURL = "http://" + window.location.host;
axios.defaults.port = ":" + window.location.port;
// 캐싱 방지
axios.defaults.headers.get['Cache-Control'] = 'no-cache';
axios.defaults.headers.get['Pragma'] = 'no-cache';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Methods'] = "GET,PUT,POST,DELETE,OPTIONS"
axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;

axios.interceptors.request.use((request) => {

    if (request.port != ":8080") {
        if (request.url.indexOf("/api/") > -1) {
            //request.baseURL = "http://api.swu_life.com";
            // request.baseURL = "http://swlife.dbconn.kr";
            request.baseURL = "http://swulife.swu.ac.kr";
            request.url = request.url.replace("/api", "");
        }
        /*if (request.url.indexOf("/py_api/") > -1) {
            request.baseURL = "http://api.nodebee.kr";
            request.url = request.url.replace("/py_api", "");
        }
        if (request.url.indexOf("/app_api/") > -1) {
            request.baseURL = "http://app-api.nodebee.kr";
            request.url = request.url.replace("/app_api", "");
        }*/
    }
    request.headers.authorization = localStorage.getItem('access_token');
    return request;
})

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(store).use(router).mount('#app');

app.component('VToggle', VToggle);
app.component('VDropdown', VDropdown);
app.component('VIntersect', VIntersect);

window.app = app;
